export const xor = (one, two) => {
    const either = !!one || !!two
    const both = !!one && !!two

    return either && !both
}